import React from 'react'
import DatepickerMethods from './datepicker.local.methods'
import DatePicker, { registerLocale } from 'react-datepicker'
import { pt, es, ru } from 'date-fns/locale'
import { getUserLocale } from '../../core/translate'
import { cn } from 'ethcss'
import styles from './datepicker.jcss'
import moment from 'moment'
import MaskedTextInput from 'react-text-mask'
import type { DatepickerProps } from './datepicker.types'

registerLocale('pt', pt)
registerLocale('es', es)
registerLocale('ru', ru)

const toValidDate = (value?: moment.MomentInput | null): Date | undefined => {
    if (value == null || value === '') {
        return undefined
    }

    const parsed = moment(value)
    return parsed.isValid() ? parsed.toDate() : undefined
}

const Datepicker = (p_: DatepickerProps) => {
    const { s_list, handleWeekSelect, handleChange } = DatepickerMethods(p_)
    const locale = getUserLocale()
    const list = s_list.map((date) => date.toDate())
    const { datepickerRef, minDate, maxDate, selected, ...datepickerProps } = p_

    return (
        <DatePicker
            locale={locale}
            {...datepickerProps}
            selected={selected ?? null}
            minDate={toValidDate(minDate)}
            maxDate={toValidDate(maxDate)}
            calendarClassName={cn(styles.datepickerWrapper, { [styles.inline]: p_.inline })}
            dateFormat="dd.MM.yyyy"
            onChange={(date: Date | null) => {
                handleChange(p_.useMoment && date ? moment(date) : date)
            }}
            highlightDates={list}
            ref={datepickerRef}
            onWeekSelect={handleWeekSelect}
            customInput={
                <MaskedTextInput type="text" mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]} />
            }
        />
    )
}

export default Datepicker
